import { render, staticRenderFns } from "./StextareaEditor.vue?vue&type=template&id=adc76822&"
import script from "./StextareaEditor.vue?vue&type=script&lang=js&"
export * from "./StextareaEditor.vue?vue&type=script&lang=js&"
import style0 from "./StextareaEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports